import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';
const baseClasses = ['block', 'text-xs', 'italic', 'text-red-500'];
const ErrorLabel = ({ children, className, style, id }) => (React.createElement("span", { "data-testid": `errorLabel${id && `-${id}`}`, className: getClassName(baseClasses, className), style: style }, children));
ErrorLabel.propTypes = {
    children: PropTypes.any.isRequired,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    style: PropTypes.object,
};
export default ErrorLabel;
